var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      { staticClass: "enable-sound", on: { click: _vm.enableSound } },
      [
        _vm.soundEnabled
          ? _c(
              "svg",
              {
                attrs: {
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M14.016 3.234q3.047 0.656 5.016 3.117t1.969 5.648-1.969 5.648-5.016 3.117v-2.063q2.203-0.656 3.586-2.484t1.383-4.219-1.383-4.219-3.586-2.484v-2.063zM16.5 12q0 2.813-2.484 4.031v-8.063q1.031 0.516 1.758 1.688t0.727 2.344zM3 9h3.984l5.016-5.016v16.031l-5.016-5.016h-3.984v-6z",
                  },
                }),
              ]
            )
          : _c(
              "svg",
              {
                attrs: {
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z",
                  },
                }),
              ]
            ),
      ]
    ),
    _vm._v(" "),
    _c("section", { staticClass: "wrapper wrapper--overview" }, [
      _c("div", { staticClass: "section-wrapper--overview" }, [
        _c("section", { staticClass: "section section--incoming incoming" }, [
          _c("div", { staticClass: "header" }, [
            _c("img", {
              staticClass: "header__logo",
              attrs: {
                src: _vm.asset(_vm.themeValue("THEME_LOGO")),
                alt: "miss-miu_logo",
              },
            }),
            _vm._v(" "),
            _c("h1", {
              domProps: { innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_NEW")) },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid" },
            _vm._l(_vm.newOrderList, function (order) {
              return _c("GridBox", { key: order.id, attrs: { order: order } })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "section section--preparation preparation" },
          [
            _c("div", { staticClass: "header" }, [
              _c("h1", {
                domProps: {
                  innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_PREP")),
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "grid" },
              _vm._l(_vm.prepOrderList, function (order) {
                return _c("GridBox", { key: order.id, attrs: { order: order } })
              }),
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section section--pick-up pick-up" }, [
        _c("div", { staticClass: "header" }, [
          _c("h1", {
            domProps: {
              innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_PICKUP")),
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "section",
          {
            class: [
              _vm.hasFeature("FEATURE_ORDERBOXES")
                ? `pick-up__grid pick-up__grid--cols-${_vm.boxColumns}`
                : "grid",
            ],
          },
          [
            _vm.hasFeature("FEATURE_ORDERBOXES")
              ? _vm._l(_vm.pickupOrderBoxList, function (order) {
                  return _c("GridBox", {
                    key: order.id,
                    attrs: { order: order },
                  })
                })
              : _vm._l(_vm.pickupOrderList, function (order) {
                  return _c("GridBox", {
                    key: order.id,
                    attrs: { order: order },
                  })
                }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }